export const organizationVideoQueryKeys = {
  all: 'ORGANIZATION_VIDEO_LIST',
  list: (params: {
    page: number;
    search: string;
    sortKey: string;
    order: string;
    filter?: { [key: string]: string[] };
  }) => [organizationVideoQueryKeys.all, params],
  filters: () => [
    organizationVideoQueryKeys.all,
    'ORGANIZATION_VIDEO_LIST_FILTERS',
  ],
};
